import { gql } from '@apollo/client';

export const QUERY_PLANS = gql`
  query Plans {
    plans {
      id
      name
      description
      price
      periodicity
      is_active
      modules
      created_at
      updated_at
    }
  }
`;

export const QUERY_PLANS_BY_ACTIVE = gql`
  query PlansByActive($active: Boolean!) {
    plans(active: $active) {
      id
      name
      is_active
    }
  }
`;
